import { useState } from "react"
import classNames from "classnames"
import { CheckBox } from "web/components"
import DataRows from "../DataRows"

export default function DataColumn(props) {
  const {
    column,
    data,
    selectedSubjectIds,
    referenceSubjectId,
    hasAverageAndMore,
    isComparison,
    onItemClick,
    handleColumnSelectionChanged,
    onToggleReference,
    viewCurrency,
  } = props

  const [isHover, setIsHover] = useState(false)

  const isReferenceComparable = referenceSubjectId === data.id
  const showReferenceAction = isReferenceComparable || isHover
  const shouldShowCurrency =
    isComparison && column.columnName !== "variance_percentages"

  const isAverageColumn = column.columnLabel === "Average"
  const shouldSpaceOutAverageColumn =
    !!referenceSubjectId && hasAverageAndMore && isAverageColumn

  const highlightClasses = classNames(
    "mr-2 mt-12 duration-200 ease-in-out border-2 border-dashed border-transparent first:ml-3",
    {
      "mr-6": shouldSpaceOutAverageColumn || isReferenceComparable,
      "cursor-pointer hover:border-primary-6": !isComparison,
    }
  )

  const tableClasses = classNames("w-52 shadow-md first:ml-0.5 table-fixed", {
    "comparison-column table-fixed border-collapse rounded-md border-0":
      isComparison,
    "shadow-lg shadow-primary-8 transition-colors": isReferenceComparable,
  })

  const thClasses = classNames(
    "text-sm h-10 color-neutral-600 border-color-neutral-900 truncate border-b border-solid pt-2.5 pl-2.5 pr-4 pb-1.5 font-medium",
    {
      "border-solid hover:border-b hover:border-color-primary-900":
        isComparison,
    }
  )

  const thLabelClasses = classNames("flex-auto h-5 truncate", {
    "items-center text-neutral-4": isComparison || onItemClick,
    "cursor-pointer hover:text-feature-6": !isComparison,
  })

  function handleSubjectNameClick(e) {
    e.stopPropagation()
    !isComparison && onItemClick(data)
  }

  return (
    <div
      className={highlightClasses}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onToggleReference(data.id, isComparison)}
    >
      {!isComparison && (
        <div>
          {showReferenceAction && (
            <div className="-mt-12 flex h-12 items-center justify-center py-4 text-sm text-primary-4">
              {isReferenceComparable ? "Remove Reference" : "Set Reference"}
            </div>
          )}
        </div>
      )}

      <table className={tableClasses}>
        <tbody>
          <tr className="bg-white last:border-b-0">
            <th className={thClasses}>
              <div className="flex items-center">
                {!isComparison && (
                  <CheckBox
                    name="toggle-column-comparison"
                    showValueLabel={false}
                    value={{
                      value: selectedSubjectIds.includes(data.id),
                    }}
                    onChange={(value) =>
                      handleColumnSelectionChanged(value, data)
                    }
                  />
                )}
                <div
                  className={thLabelClasses}
                  onClick={handleSubjectNameClick}
                >
                  {isComparison ? column.columnLabel : column.columnName}{" "}
                  {shouldShowCurrency && `(${viewCurrency})`}
                </div>
              </div>
            </th>
          </tr>
          <DataRows isComparison={isComparison} {...props} />
        </tbody>
      </table>
    </div>
  )
}
